var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerTags({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 71,
    viewBox: "0 0 68 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6241,
    cy: 9.61067,
    r: 9.61067,
    fill: "#28345A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.248 43.248C43.248 48.0534 32.3653 48.0534 20.4227 48.0534C8.48006 48.0534 1.20133 48.0534 0 43.248C0 31.3054 9.6814 21.624 21.624 21.624C33.5666 21.624 43.248 31.3054 43.248 43.248Z",
    fill: "#28345A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5143_19825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6045 22.9108C63.6045 22.6728 63.4996 22.4443 63.328 22.2824L59.4089 18.3221C59.2372 18.1508 59.0084 18.046 58.77 18.0365L42.4354 17.3796C42.1589 17.3796 41.911 17.4748 41.7203 17.6652L12.9703 46.6727C12.5984 47.044 12.5984 47.6437 12.9703 48.015L33.882 69.1208C34.0631 69.3017 34.3015 69.4064 34.559 69.4064C34.8165 69.4064 35.0548 69.3017 35.236 69.1208L63.986 40.1039C64.1671 39.9135 64.272 39.6564 64.2625 39.3994L63.6045 22.9108ZM55.4611 31.5168C54.0212 32.9734 51.6755 32.9734 50.2356 31.5168C48.7957 30.0603 48.7957 27.6993 50.2356 26.2428C51.6755 24.7862 54.0212 24.7862 55.4611 26.2428C56.901 27.6993 56.901 30.0603 55.4611 31.5168Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2918 16.3419C64.4145 15.4565 63.3942 14.7711 62.2785 14.3046C61.1724 13.8476 59.9709 13.6001 58.7312 13.6001C56.252 13.6001 53.9253 14.5711 52.1707 16.3419C51.7416 16.7703 51.3697 17.2367 51.0455 17.7223C49.3196 20.2927 49.0144 23.558 50.111 26.3855C50.5592 27.5374 51.2458 28.6131 52.1707 29.5461C53.0861 30.4695 54.1541 31.174 55.327 31.6405C55.3747 31.6024 55.4128 31.5643 55.4605 31.5167C55.8992 31.0788 56.2043 30.5457 56.3759 29.9935C55.3175 29.6413 54.3448 29.032 53.5248 28.2133C52.6952 27.366 52.104 26.3664 51.7607 25.3097C50.912 22.7774 51.4651 19.8643 53.4008 17.8175C53.439 17.7699 53.4866 17.7318 53.5248 17.6842C54.917 16.2752 56.7669 15.5041 58.7312 15.5041C60.6956 15.5041 62.5455 16.2752 63.9282 17.6842C65.368 19.1407 66.0927 21.0447 66.0927 22.9487C66.0927 24.8527 65.368 26.7567 63.9282 28.2133C63.89 28.2514 63.8519 28.2895 63.8137 28.318L63.9091 30.6885C64.4049 30.3648 64.8626 29.9745 65.2918 29.5461C68.8962 25.9095 68.8962 19.9785 65.2918 16.3419Z",
    fill: "#28345A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5143_19825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.3067,
    height: 57.12,
    fill: "white",
    transform: "translate(12.6934 13.6001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTags);
export default __webpack_public_path__ + "static/media/customerTags.281e707395a694f1923469f506e4819b.svg";
export { ForwardRef as ReactComponent };